import CrudTab from "@/components/CrudTab";

const FIELDS = [
  { key: "name", label: "When the bank text contains", type: "text" },
  { key: "rename", label: "Change the description to", type: "text" },
  { key: "active", label: "Active", type: "switch" },
];
const COLUMNS = [
  { key: "name", label: "Bank text contains", render: (r) => <span className="font-mono text-xs">{r.name}</span> },
  { key: "rename", label: "Becomes" },
];

export default function PayeeRules({ onChange }) {
  return (
    <CrudTab table="payee_rules" singular="Rule" prefix="payee-rule" fields={FIELDS} columns={COLUMNS}
      blank={{ name: "", rename: "", active: true }} onChange={onChange}
      header={<div><h2 className="font-display text-xl font-semibold">Payee rules</h2>
        <p className="text-sm text-muted-foreground">Tidy bank descriptions automatically on every upload. The longest matching text wins.</p></div>} />
  );
}
